import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Actions from "store/report/actions";
import { RadioGroup } from "../components/RadioGroup";

export const PrescriptionDrugsFilter = ({ report, plans }) => {
  const dispatch = useDispatch();
  const prescriptionDrugsOption = useSelector((state) => state.report.prescriptionDrugsOption);
  if (report.version === "v1") return null;

  const drugsListLength = [...report.expected.drugs, ...report.unexpected.drugs].length;
  const hasDrugs = plans?.some((plan) => plan.pbmId) && drugsListLength > 0;
  if (!hasDrugs) return null;
  return (
    <RadioGroup
      name="prescription-drugs-option"
      label="Show all drugs:"
      options={[
        {
          value: "lowest",
          label: "at the lowest cost pharmacy",
        },
        {
          value: "retail-only",
          label: "with insurance at Retail Pharmacy",
        },
        {
          value: "mail-order-only",
          label: "with insurance through Mail Order Pharmacy",
        },
        {
          value: "cash-pay",
          label: "cash pay at Retail Pharmacy",
        },
      ]}
      onChange={(value) => {
        dispatch(
          Actions.Creators.switchState({
            prescriptionDrugsOption: value,
          }),
        );
      }}
      value={prescriptionDrugsOption}
      rightAligned
    />
  );
};
